import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import "../../../assets/styles/admin/opd.scss";
import {
  Button,
  Select,
  Row,
  Col,
  Table,
  InputNumber,
  Checkbox,
  Typography,
  Space,
} from "antd";
import HeaderBar from "../../../components/header/headerBar";
import axios from "axios";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import LOGO from "../../../assets/images/logo.png";

interface Props {
  data?: any;
  refPrint?: any;
  // type?: string;
}

const PrintPage2: React.FC<Props> = ({ data, refPrint }) => {
  const { Text } = Typography;
  const history = useHistory();
  const refPrintV2: any = useRef("pagePrintV2");

  const [memberId, setMemberId] = useState<any>([]);
  const [medicalRecordId, setMedicalRecordId] = useState<any>([]);
  const [type, setType] = useState<any>([]);
  const [medicalData, setMedicalData] = useState<any>([]);
  const [docname, setdocname] = useState<string>("");
  const [docopion, setDocopion] = useState<string>("");

  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  let query = useQuery();
  // const [data, setdata] = useState<any>([]);
  const columns = [
    {
      title: "",
      dataIndex: "index",
      colSpan: 1,
      key: "key",
      align: "center" as const,
      render: (record: any, data: any, index: number) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      colSpan: 1,
      key: "key",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      colSpan: 1,
      key: "key",
      align: "center" as const,
    },
    {
      title: "Unit",
      dataIndex: "unit",
      colSpan: 1,
      key: "key",
      align: "center" as const,
    },
  ];

  const medicine = [
    {
      index: "1",
      name: "AAD (Avdomen,Thigh,Arm,Hip)",
      quantity: "1",
      unit: "Area",
    },
    {
      index: "2",
      name: "Acne Clear",
      quantity: "1",
      unit: "Area",
    },
    {
      index: "3",
      name: "Under Arms  Reju",
      quantity: "1",
      unit: "Area",
    },
    {
      index: "4",
      name: "Meso Lift",
      quantity: "1",
      unit: "Area",
    },
    {
      index: "5",
      name: "Fine Thread (1 pcs)",
      quantity: "1",
      unit: "Area",
    },
  ];

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    const memberId = query.get("memberId");
    const medicalRecordId = query.get("medicalRecordId");
    axios
      .get(
        `/member-opd/print?memberId=${memberId}&medicalRecordId=${medicalRecordId}`
      )
      .then((res) => {
        console.log("res", res);
        setDocopion(res?.data?.doctorOpinion);
        setdocname(res?.data?.doctor);
        setMedicalData(res?.data?.recommendedTreatments);
      });

    const type = query.get("type");
    setType(type);
    console.log("type", type);
  };
  return (
    <div className="opd-custom-list">
      <div
        ref={refPrint}
        className="page-print-v1"
        style={{ marginTop: "20px", background: "#FFFFFF" }}
      >
        <Row>
          <Col span={8} offset={8}>
            <img src={LOGO} alt="Dermaster" style={{ width: "100%" }} />
          </Col>
          <Col span={8} style={{ alignSelf: "flex-end", textAlign: "end" }}>
            <p>
              <span>สาขา : {data?.branch}</span>
            </p>
          </Col>
        </Row>

        <div className="line-title"></div>

        <Row className="title-print">
          <Col span={8}>
            <p>
              ชื่อ (Name): <span>{data?.name}</span>
            </p>
          </Col>
          <Col span={8}>
            <p>
              อายุ (Age): <span>{data?.age}</span>
            </p>
          </Col>
          <Col span={8} style={{ textAlign: "end" }}>
            <p>
              <span>{data?.code}</span>
            </p>
          </Col>
        </Row>

        <Row className="text-print">
          <Col span={8}>
            <p>
              เบอร์มือถือ (Mobile):{" "}
              <span>
                {data?.phoneNumbersFirst
                  ? "+" +
                    data?.phoneNumbersFirst?.code +
                    " " +
                    data?.phoneNumbersFirst?.phone
                  : "-"}
              </span>
            </p>
          </Col>
          <Col span={16}>
            <div className="history history-print-2">
              <p>
                แพ้ยา (Allergy History): <span>{data?.allergyHistory}</span>
              </p>
            </div>
            <div
              className="history history-print-2"
              style={{ marginTop: "5px" }}
            >
              <p>
                โรคประจำตัว (UnderlyingDisease):{" "}
                <span>{data?.underlyingDisease}</span>
              </p>
            </div>
          </Col>
        </Row>

        <div className="line-title"></div>

        <Row className="area-print">
          {type === "Doctor" ? (
            <>
              <Col span={12}>
                <Text>Doctor Opinion</Text>
                <br />
                <Text style={{ paddingLeft: "10px" }}>{docopion}</Text>
              </Col>
              <div className="line-right"></div>
              <Col span={10} offset={1}>
                <Text>Recommended Treatment</Text>
                <Table
                  className="table-recomend"
                  columns={columns}
                  dataSource={medicalData}
                  pagination={false}
                ></Table>

                <Row justify="end">
                  <Text style={{ fontSize: "7px" }}>{docname}</Text>
                </Row>
              </Col>
            </>
          ) : (
            <Col span={12} className="line-right" />
          )}
        </Row>
      </div>
    </div>
  );
};
export default PrintPage2;
